import React from 'react';
import BodyClassName from 'react-body-classname';
import { compose, withProps, withHandlers } from 'recompose';
import { Page } from 'components/core/Page';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PaidTemplateHeaderImages, PPC_TYPE_STORAGE } from './constants';
import { PAGE_TYPES } from '@sparefoot/tracking-events';
import { withExperiment } from '@sparefoot/react-core/decorators';
import { withPageViewTracking } from 'components/core/library/tracking-utils';

import { withSearchHandler } from 'decorators';
import { PLPHeroDynamic } from 'components/plp/PLPHeroDynamic';
import { StickySearchBar } from 'components/landing/StickySearchBar';
import { WhySpareFootSection } from '../../components/plp/WhySpareFootSection';
import PLPHowItWorksSection from '../../components/plp/PLPHowItWorksSection/PLPHowItWorksSection';
import PLPReviewSection from '../../components/plp/PLPReviewSection/PLPReviewSection';
import PLPFooterSection from '../../components/plp/PLPFooterSection/PLPFooterSection';
import PLPQuickLinks from '../../components/plp/PLPQuickLinks/PLPQuickLinks';


import './PaidTemplatePage.scss';
import { PLPFacilitiesSection } from '../../components/plp/PLPFacilitiesSection';

export const enhance = compose(
	connect((state) => {
		return {
			storageType: state.pageMeta.storageType,
			location: state.pageMeta.location,
		};
	}),
	withPageViewTracking(PAGE_TYPES.PPC),
	withProps(({ storageType }) => ({
		searchType: storageType !== PPC_TYPE_STORAGE ? 'vehicle' : 'storage',
		additionalSearchParams: storageType !== PPC_TYPE_STORAGE ? { vehicle: storageType.toLowerCase() } : undefined
	})),
	withSearchHandler,
	withHandlers({
		// Provides title for cards etc
		buildTitle: () => (location, keyword) => {
			// Only appends 'storage' if keyword is not 'Self-Storage'
			let appendStorageString =
				keyword !== PPC_TYPE_STORAGE ? `${keyword} Storage` : keyword;

			if (location) {
				return `Find ${appendStorageString} in ${location}`;
			}

			return `Find ${appendStorageString} Near You`;
		},
		// Determines images used in cards
		// defined in constants.js file
		getHeaderImage: () => (keyword) => {
			return (
				PaidTemplateHeaderImages[keyword] ||
				PaidTemplateHeaderImages['default']
			);
		},
	}),
	withProps(({ storageType, location, buildTitle, getHeaderImage }) => {
		const title = buildTitle(location, storageType);
		const imageSrc = getHeaderImage(storageType);

		return {
			title,
			pageType: storageType, // storageType is validated in getPaidTemplatePage action
			imageSrc,
		};
	}),
	withSearchHandler,
	withExperiment('sf_14851_sfdc_paid_landing_hero_promo_test'),
	withExperiment('sf_15342_geolocation_sfdc')
);

export function PaidTemplatePage({ title, pageType, handleSearch, location, sf14851Variation, sf15342Variation }) {
	const quickLinks = [
		{ id: 'how-it-works', label: 'How It Works' },
		{ id: 'reviews-section', label: 'Reviews' },
		{ id: 'why-sparefoot', label: 'Why Sparefoot' },
	];

	return (

		<BodyClassName className="paid-template-page" >
			<Page>
				<StickySearchBar
				 triggerId="quick-links-container" 
				 handleSearch={handleSearch} 
				 hasJumpToSection={<PLPQuickLinks quickLinks={quickLinks} />}
				 className='plp-sticky-search' />
				<PLPHeroDynamic
					headline={title}
					searchButtonText="Find units"
					storageType={pageType}
					handleSearch={handleSearch}
					sf14851Variation={sf14851Variation}
				/>
				<PLPQuickLinks id='quick-links-container' quickLinks={quickLinks} />
				{/* TODO: add facilities section */}
				{ sf15342Variation === 'variation1' && ( // sf_15342_geolocation_sfdc
					<PLPFacilitiesSection />
				)}
				<PLPHowItWorksSection pageType={pageType} />
				<PLPReviewSection pageType={pageType}/>
				<WhySpareFootSection />
				<PLPFooterSection pageType={pageType} location={location} handleSearch={handleSearch} />
			</Page>
		</ BodyClassName>

	);
}

PaidTemplatePage.propTypes = {
	title: PropTypes.string,
	pageType: PropTypes.string,
	imageSrc: PropTypes.string,
	handleSearch: PropTypes.func.isRequired,
	location: PropTypes.string,
	sf14851Variation: PropTypes.string
};

export default enhance(PaidTemplatePage);
